import { useState} from 'react';
import { 
  Menu, X,
 Layers
} from 'lucide-react';


export function Navbar ({current_balance, role}) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-blue-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center gap-2">
            <div className="p-1.5 rounded text-white">
              <img 
                    src="/favicon.ico" 
                    alt="MIA Logo" 
                    className="w-10 h-10 object-contain"
              />
            </div>
            <span className="font-bold text-xl text-blue-900">MIA</span>
            <span className="text-sm font-medium text-blue-600 hidden sm:block border-l border-blue-300 pl-2 ml-2">
              In-Store Marketing Intelligent Agent
            </span>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-6 text-sm font-medium">
            {role === "Admin" && (
              <a href="#" onClick={() => window.open("/UserManagement", "_blank")} className="hover:text-blue-600 transition-colors text-blue-900">User Management</a>
            )}
            <a href="#core-flow" className="hover:text-blue-600 transition-colors text-blue-900">Process</a>
            <a href="#simulator" className="hover:text-blue-600 transition-colors text-blue-900">Walkthrough</a>
            <a href="#innovation" className="hover:text-blue-600 transition-colors text-blue-900">AI Tools</a>
            <a className="inline-flex items-center gap-2 hover:text-blue-600 transition-colors text-blue-900">Balance: {parseInt(current_balance)}
</a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-blue-900">
              {isOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-blue-100 px-4 py-4 space-y-3 shadow-lg">
          {role === "Admin" && (
              <a href="#" onClick={() => window.open("/UserManagement", "_blank")} className="block text-blue-900 font-medium">User Management</a>
          )}
          <a href="#core-flow" onClick={() => setIsOpen(false)} className="block text-blue-900 font-medium">Process</a>
          <a href="#simulator" onClick={() => setIsOpen(false)} className="block text-blue-900 font-medium">Walkthrough</a>
          <a href="#innovation" onClick={() => setIsOpen(false)} className="block text-blue-900 font-medium">AI Tools</a>
          <a className="block text-blue-900 font-medium">Balance: {parseInt(current_balance)}</a>
        </div>
      )}
      
    </nav>
  );
};